module.exports = __webpack_public_path__ + "static/img/state-grid_19.8d2b2ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-home/state-grid_19.png
// module id = Y1ad
// module chunks = 1